module.exports = __webpack_public_path__ + "img/6-preview.57f8dd84.jpg";